import React from 'react'
import {Modal} from 'react-bootstrap'
import {Navigate, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'
import {
  GetReportId,
  storeReportId,
} from '../pages/UserPages/reports-analytics/reportSlices/reportAnalytics'
import {useDispatch, useSelector} from 'react-redux'

const SuccessPopup = ({
  show,
  handleClose,
  bulkMessageData,
  backdrop,
  firstTimeSend,
  errorMessage,
}: any) => {
  const navigate = useNavigate()
  const ReportId = useSelector(GetReportId)

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        backdrop={backdrop ? backdrop : 'static'}
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px h-auto celebration-modalpopup'
        show={show}
        onHide={handleClose}
      >
        <div className='container-xxl p-0'>
          <div
            className='modal-body border-bottom campaign-model'
            style={errorMessage && !firstTimeSend ? {paddingTop: '40 !important'} : {}}
          >
            {errorMessage && !firstTimeSend ? (
              <div className='col-md-12 text-center'>
                <h2 className='mb-10'>Your campaign failed to send</h2>
                <div className='col-12 mb-10 alert alert-danger'>{errorMessage}</div>
              </div>
            ) : (
              <>
                <div className='confetti'>
                  {Array(13)
                    .fill('')
                    .map((_, i: number) => (
                      <div key={i} className='confetti-piece'></div>
                    ))}
                </div>
                <div className='row'>
                  <div className='col-md-12 text-center'>
                    <h2>
                      Your campaign has been
                      <br /> submitted successfully!
                    </h2>
                    <p
                      style={{
                        margin: '16px 0px 20px 0px',
                      }}
                    >
                      Reports will be generate in real-time as results are from our carriers, so
                      check back in as often as you like! For your convenience a soft copy of the
                      report will be sent to your requested email address(s).
                    </p>
                  </div>
                </div>
              </>
            )}

            {errorMessage && !firstTimeSend ? (
              <div className='d-flex align-items-center justify-content-center'>
                <button
                  type='submit'
                  className='btn btn-lg btn-danger me-5 fw-500'
                  onClick={handleClose}
                >
                  <span className='indicator-label'>Close</span>
                </button>
              </div>
            ) : (
              <div className='d-flex align-items-center justify-content-center'>
                <button
                  type='submit'
                  className='btn btn-lg btn-light-primary me-5 fw-500'
                  onClick={() => {
                    handleClose()
                    navigate('/new-message')
                  }}
                >
                  <span className='indicator-label'>Send another</span>
                </button>
                {!!ReportId?.id ? (
                  <button
                    type='submit'
                    className='btn btn-lg  btn-primary me-5 fw-500'
                    onClick={() => {
                      handleClose()
                      navigate(`/eofy/snapshot`)
                    }}
                  >
                    <span className='indicator-label'>View report</span>
                  </button>
                ) : null}
              </div>
            )}
            {firstTimeSend ? (
              <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 deactivate-account mb-8 mt-8'>
                <KTSVG
                  path='/media/icons/duotune/general/gen044.svg'
                  className='svg-icon-2tx svg-icon-primary me-4'
                />
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                  <div className='mb-3 mb-md-0 fw-bold'>
                    <div className='fs-7 text-gray-600 pe-7'>
                      Your message is going through a security check. This may cause a delay in
                      sending. Please call if your message is urgent and we can expedite the
                      process.
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SuccessPopup
